import React, { useEffect, useState } from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import 'react-multi-carousel/lib/styles.css';
import '../styles/globals.css';
import { BingoLobbyContextProvider } from '../store/bingolobbycontext';
import Layout from '../components/layout/Layout';
import { appWithTranslation } from 'next-i18next';
import defaultTheme from '../themes/default';
import { useRouter } from 'next/router';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Roboto, sans-serif;
    font-size: 10px;
    background: transparent;
  }
`;

function BingoIframe({ Component, pageProps }) {
    const router = useRouter();
    const [theme, setTheme] = useState(null);

    useEffect(() => {
        if (!router.isReady) {
            return;
        }

        const themes = Array.from(
            new Set(
                /** @type {Array<string | undefined>} */ ([
                    router.query.theme,
                    pageProps.theme,
                ])
                    .filter((theme) => theme)
                    .map((theme) => theme.trim())
            )
        );

        /**
         * @param {string} themeName
         */
        const loadTheme = async (themeName) => {
            try {
                const importedTheme = await import(`../themes/${themeName}`);

                return importedTheme.default;
            } catch (error) {
                return null;
            }
        };

        async function loadThemes() {
            let loadedTheme = null;
            for (const themeName of themes) {
                console.log(`Loading theme "${themeName}"`);

                loadedTheme = await loadTheme(themeName);

                if (loadedTheme) {
                    break;
                } else {
                    console.warn(`Theme "${themeName}" not found.`);
                }
            }

            if (!loadedTheme) {
                loadedTheme = defaultTheme;
                console.log('Falling back to default theme.');
            }

            setTheme(loadedTheme);
        }

        loadThemes();
    }, [router.isReady, router.query.theme, pageProps.theme]);

    if (!theme) {
        return null;
    }

    return (
        <BingoLobbyContextProvider>
            <ThemeProvider theme={theme}>
                <GlobalStyle />
                <Layout>
                    <Component {...pageProps} />
                </Layout>
            </ThemeProvider>
        </BingoLobbyContextProvider>
    );
}

export default appWithTranslation(BingoIframe);
